// @flow

import React from "react";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as mappers from "../../utils/mappers";
import * as v from "../../utils/validators";
import * as formatters from "../../utils/formatters";
import { errors } from "../../utils/errors";
import { placeholders } from "../../utils/placeholders";

import {
  PURPOSE_KIND,
  FEDERAL_STATE,
  LIQUIDITY_DESCRIPTION,
  LIQUIDITY_ESTIMATED_DELIVERY_DATE,
  AMOUNT
} from "./formFields";
import { mapPurposeKind, getKind } from "./mappers";

import { type InvestmentSectionProps } from "../../types/details";

const InvestmentLiquidity = ({
  kind,
  initialValues,
  handleSubmit,
  isLocked
}: InvestmentSectionProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Investitionsvorhaben"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && mapPurposeKind(purposeKind.kind);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: AMOUNT,
            caption: () => "Betrag / Höhe"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: LIQUIDITY_DESCRIPTION,
            caption: () => "Beschreibung"
          }}
        />
        <EditableField
          fieldControlProps={{
            name: LIQUIDITY_ESTIMATED_DELIVERY_DATE,
            caption: () => "Voraussichtlicher Bedarfszeitpunkt",
            validate: v.combineWithPrefillCheck(errors.requiredField())
          }}
          type="datePicker"
          inputProps={{
            datePickerFormFormat: "yyyy-MM-dd",
            placeholder: placeholders.pleaseSelect
          }}
          displayValue={mappers.dateMapper}
        />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentLiquidity;
